<!-- =========================================================================================
  File Name: UserProfile.vue
  Description: Thông tin chi tiết tài khoản. Có chức năng thay đổi mật khẩu.
========================================================================================== -->
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const userApi = ClientFactory.get("users");
const apiFile = ClientFactory.get("files");
import md5 from "md5";

export default {
  data() {
    return {
      inputAvatar: "",
      hasFileAvatar: false,
      userInfo: {},
      state: {
        editUserModal: false,
        btnLoading: false,
      },
      password: {
        new: "",
        confirm: "",
      },
      body: {
        id: -1,
        username: "",
        password: "",
      },
    };
  },
  async created() {
    this.getUserInfo();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async getUserInfo() {
      this.loading(this.$vs);
      let username = this.AppActiveUser.username;
      this.userInfo = await userApi.get(username);
      this.closeLoading();
    },
    async submit() {
      this.state.btnLoading = true;
      this.body = {
        id: this.userInfo.id,
        username: this.userInfo.username,
        password: md5(this.password.new),
      };
      let response = await userApi.update(this.body);
      if (typeof response.error !== "undefined") {
        this.state.btnLoading = false;
        return this.notify({
          error: true,
          title: "Thông báo",
          text: error,
        });
      }
      this.$store.dispatch("auth/logout");
    },

    validateAvatar(event) {
      if (event.length != 0) {
        this.inputAvatar = event[0];
        this.hasFileAvatar = true;
        this.SubmitUploadAvatar();
      } else {
        this.hasFileAvatar = false;
        this.inputAvatar = null;
      }
    },

    async SubmitUploadAvatar() {
      this.loading(this.$vs);
      let body = {};
      let responseAVT = 0;
      if (this.inputAvatar != null) {
        responseAVT = await apiFile.uploadFile(this.inputAvatar);
        console.log(responseAVT);
        if (
          typeof responseAVT.error !== "undefined" ||
          responseAVT.data.status === "failed"
        ) {
          this.closeLoading();
          return this.notify({
            error: true,
            text: responseAVT.error || responseAVT.data.message,
          });
        }

        body.file_avt_id = responseAVT.data.fileIds[0];
      }

      const result = await userApi.update_avatar(body);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.getUserInfo();
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    handleCloseModal() {
      // reset validate message
      this.$validator.reset();
      //reset input forms
      // this.password = {
      //     new: "",
      //     confirm: ""
      // }
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    validateForm() {
      return (
        !this.errors.any() &&
        this.password.new != "" &&
        this.password.new == this.password.confirm &&
        this.userInfo.username !== ""
      );
    },
  },
  destroyed() {
    // reset validate message
    this.$validator.reset();
  },
};
</script>

<template>
  <div id="UserInfo">
    <CCard>
      <CCardHeader>
        <h4>Thông tin tài khoản</h4>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="6" class="mb-4">
            <CRow class="user-info">
              <div style="margin-top: 4px">
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <form action="" method="post" id="form-image">
                      <CInputFile
                        v-validate="'required'"
                        @change="validateAvatar($event)"
                        id="imageUpload"
                      />
                      <!-- <input
                        type="file"
                        id="imageUpload"
                        accept=".png, .jpg, .jpeg"
                      /> -->
                      <label for="imageUpload" id="icon_upload" ><i class="bx bxs-camera" id="change-avatar-icon"/></label>
                    </form>
                  </div>
                  <div class="avatar-preview">
                    <CImg
                      :src="
                        userInfo.avatar ||
                          require('@/assets/images/no_avatar.png')
                      "
                      class="avatar-img"
                      id="imagePreview"
                    />
                  </div>
                </div>
              </div>
              <CCol sm="9">
                <CRow>
                  <span class="user-label">Nhân viên: </span
                  >{{ userInfo.full_name }}
                </CRow>
                <CRow class="info-row">
                  <span class="user-label">Phòng ban: </span
                  >{{ userInfo.department_name }}
                </CRow>
                <CRow class="info-row">
                  <span class="user-label">Chức danh: </span
                  >{{ userInfo.position }}
                </CRow>
                <CRow class="info-row">
                  <span class="user-label">Tài khoản: </span
                  >{{ userInfo.username }}
                </CRow>
                <CRow class="info-row">
                  <div class="d-flex flex-wrap">
                    <vs-tooltip color="primary">
                      <vs-button
                        @click="state.editUserModal = true"
                        gradient
                        v-if="userInfo.username"
                        size="small"
                        square
                        class="mr-2 ml-0"
                        color="primary"
                        type="filled"
                        icon
                        ><i class="bx bxs-edit"></i
                      >&nbsp;Thay đổi mật khẩu</vs-button>
                      <template #tooltip>
                       Thay đổi mật khẩu
                      </template>
                    </vs-tooltip>
                  </div>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol md="3">
            <CRow class="info-row">
              <span class="result-label">Trạng thái: </span>
              <CBadge v-if="userInfo.status == 1" color="success"
                >Đã kích hoạt</CBadge
              >
              <CBadge v-else color="danger">Chưa kích hoạt</CBadge>
            </CRow>
            <CRow class="info-row">
              <span class="result-label">Ngày tạo: </span>
              {{ userInfo.createdDate || "23/04/2021" }}
            </CRow>

            <CRow class="info-row">
              <span class="result-label">Vai trò: </span
              >{{ userInfo.account_type }}
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <vs-dialog
      prevent-close
      @close="handleCloseModal"
      width="550px"
      v-model="state.editUserModal"
    >
      <template #header>
        <h4 class="not-margin">
          Thay đổi thông tin tài khoản
        </h4>
      </template>
      <CInput label="Tên người dùng" :value="userInfo.username" disabled />

      <CInput
        label="Mật khẩu mới"
        v-model="password.new"
        ref="password"
        v-validate="'required|min:6'"
        name="password"
        type="password"
        class="mt-3"
      />

      <CInput
        label="Xác nhận mật khẩu"
        v-model="password.confirm"
        v-validate="'confirmed:password|min:6'"
        name="confirm-password"
        type="password"
        class="mt-3"
      />
      <span class="text-danger text-sm">{{
        errors.first("confirm-password")
      }}</span>

      <template #footer>
        <div class="footer-dialog">
          <vs-button
            class="m-0"
            square
            :loading="state.btnLoading"
            :disabled="!validateForm"
            block
            @click="submit"
          >
            Cập nhật
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<style lang="scss">
#UserInfo {
  .avatar-img {
    width: 100px;
    height: 100px;
    border: 1px solid #cfcfcf;
    border-radius: 10px;
    margin-right: 10px;
  }
  .user-label {
    width: 90px;
    font-weight: bold;
  }

  .info-row {
    margin-top: 2px;
  }

  .result-label {
    width: 150px;
    font-weight: bold;
  }

  .avatar-upload {
    position: relative;
    max-width: 205px;
    margin: auto;
    margin-bottom: 20px;

    .avatar-edit {
      position: absolute;
      right: 40px;
      z-index: 1;
      top: 90px;
      input {
        display: none;
      }
      #icon_upload {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin-bottom: 0;
        border-radius: 100%;
        background: #ffffff;
        border: 1px solid #d2d6de;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        cursor: pointer;
        font-weight: normal;
        transition: all 0.2s ease-in-out;
        &:hover {
          background: #f1f1f1;
          border-color: #d6d6d6;
        }
        #change-avatar-icon {
          color: #337ab7;
          position: absolute;
          left: 0;
          right: 0;
          text-align: center;
          line-height: 30px;
          margin: auto;
        }
        
      }
    }
  }
  #avatar-col {
    width: 6rem;
    height: 6.2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  #avatar-col img {
    width: 6rem;
    height: 6rem;
    object-fit: cover;
    object-position: center;
  }

  .info {
    table {
      td {
        vertical-align: top;
        min-width: 90px;
        padding-bottom: 0.8rem;
        word-break: break-word;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }

    .gallery-contanner,
    .introduction {
      min-height: 280px;
    }
  }
}
</style>
